// Fix: Import React to resolve 'Cannot find namespace React' for React.ReactNode type
import React from 'react';

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER',
  GUEST = 'GUEST'
}

export interface User {
  id: string;
  email: string;
  role: UserRole;
  name: string;
  walletId?: string;
  walletAsset?: string;
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export interface NavItem {
  label: string;
  path: string;
  icon: React.ReactNode;
}